import { saveSavedSearch } from '../../Services/PropertyListService'
import keycloak from '../../../keycloak'
import { getUserSFId } from '../../../PropertySearch/Utility/Utility'
import { readyToUpdate, pendingResponse } from '../../../PropertyList/Utility/PropertyListUtility'

class UpdatePropertyList {
    constructor(fieldsToUpdate, action = "modify") {
        this.fieldsToUpdate = fieldsToUpdate
        this.action = action
    }

    getPayload() {
        try {
            let data = {}
            const user_SFId = getUserSFId()
            // console.log(' keycloak :: ', keycloak)
            // let polarisLastModifiedByUserName = keycloak && keycloak.tokenParsed && keycloak.tokenParsed.name ? keycloak.tokenParsed.name : ''
            // console.log(' polarisLastModifiedByUserName :: ', polarisLastModifiedByUserName)

            this.fieldsToUpdate.push({ key: 'userId', value: keycloak.subject })
            this.fieldsToUpdate.push({ key: 'omniViewUserId', value: user_SFId })
            this.fieldsToUpdate.push({ key: 'polarisLastModifiedById', value: keycloak.subject })
            this.fieldsToUpdate.push({ key: 'polarisLastModifiedByUserName', value: keycloak.tokenParsed.name })
            this.fieldsToUpdate.push({ key: 'isCart', value: true })

            this.fieldsToUpdate.forEach(item => {
                data[item.key] = item.value
            })
            // data.lastModifiedById = user_SFId
            const payload = {
                "action": this.action,
                "data": data
            }

            return payload
        }
        catch (e) {
            console.log('Error in getPayload in UpdatePropertyList:: ', e)
        }
    }

    async update() {
        if (await readyToUpdate()) {
            const payload = this.getPayload()
            return await saveSavedSearch(payload)
        } else {
            return await pendingResponse()
        }

    }

}

export default UpdatePropertyList
